import React, { useEffect, useReducer, useState, useMemo } from "react"
import { get, isEmpty, isNaN } from "lodash"

import { IndexesTemplate } from "components/templates/top/indexes"
import {
  requestPriceListAPIs,
  usePriceList,
} from "components/actions/priceList"
import { APIResponse } from "redux/apis/types"
import APIs from "redux/apis"
import { EXCHANGE, SECURITY_TYPE } from "config/const"
import { withRouter, WithRouterProps } from "react-router"
import uuid from "uuid"
import store from "redux/store"
import { pageLoadRegist } from "redux/ducks/PageLoad"
import { useLodingTrigger, LoadingTriger } from "components/actions/loading"
import { LoadStateType } from "redux/ducks/PageLoad"
import { useSelector } from "react-redux"

const initialPriceListState = {
  name: "Top.Index.Main",
}

export const Indexes: WithRouterProps<React.FC> = withRouter(({ location }) => {
  const [priceListState, usePriceListReducer] = useReducer(
    usePriceList,
    initialPriceListState
  )
  const [indexData, setIndexData] = useState()
  const [selectData, setSelectData] = useState<number>(0)
  const [detailsData, setDetailsData] = useState<APIResponse.Res>([])
  const loadResistId = useMemo(() => uuid(), [])
  const { loading, setLoading } = useLodingTrigger()
  const isPageLoading = useSelector(
    (state: { PageLoad: LoadStateType }) => state.PageLoad.load
  )

  useEffect(() => {
    store.dispatch(pageLoadRegist(loadResistId, true))
    requestPriceListAPIs(priceListState).then((value: APIResponse.Res) => {
      setIndexData(value)
      store.dispatch(pageLoadRegist(loadResistId, false))
    })
  }, [priceListState])

  useEffect(() => {
    if (isEmpty(indexData) || !isEmpty(location.state) || isNaN(selectData))
      return
    store.dispatch(pageLoadRegist(loadResistId, true))
    const setData = async () => {
      const dataResult = get(indexData, "ResultList")
      const data = dataResult[selectData]
      const symbolDetail = await APIs.SymbolDetail.SymbolDetail({
        Symbol: get(data, "Symbol"),
        Exchange: get(data, "Exchange", EXCHANGE.TSE.id),
        SecurityType: get(data, "SecurityType", SECURITY_TYPE.Equity.id),
      })
      setDetailsData(symbolDetail)
      store.dispatch(pageLoadRegist(loadResistId, false))
    }
    setData()
  }, [indexData, selectData])

  useEffect(() => {
    if (isEmpty(location.state)) return
    store.dispatch(pageLoadRegist(loadResistId, true))
    const setData = async () => {
      const data = get(location.state, "rowData")
      const symbolDetail = await APIs.SymbolDetail.SymbolDetail({
        Symbol: get(data, "Symbol"),
        Exchange: get(data, "Exchange", EXCHANGE.TSE.id),
        SecurityType: get(data, "SecurityType", SECURITY_TYPE.Equity.id),
      })
      location.state = {}
      setDetailsData(symbolDetail)
      store.dispatch(pageLoadRegist(loadResistId, false))
    }
    setData()
  }, [location.state])

  useEffect(() => {
    if (!loading) return
    setLoading(false)
    store.dispatch(pageLoadRegist(loadResistId, true))
    requestPriceListAPIs(priceListState).then((value: APIResponse.Res) => {
      setIndexData(value)
      store.dispatch(pageLoadRegist(loadResistId, false))
    })
  }, [loading])

  //ページ更新
  useEffect(() => {
    if (isPageLoading) {
      store.dispatch(pageLoadRegist(loadResistId, true))
      requestPriceListAPIs(priceListState).then((value: APIResponse.Res) => {
        setIndexData(value)
        store.dispatch(pageLoadRegist(loadResistId, false))
      })
    }
  }, [isPageLoading])

  return (
    <LoadingTriger.Provider value={{ loading, setLoading }}>
      <IndexesTemplate
        IndexData={indexData}
        indexListAction={usePriceListReducer}
        detailsData={detailsData}
        selectData={selectData}
        setSelectData={setSelectData}
        transitionData={get(location.state, "rowData")}
      />
    </LoadingTriger.Provider>
  )
})
